import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import themes from '~/themes';

export const Container = styled.div`
  width: 100%; 
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%; 
  margin-top: 50px;
  border-top: 1px solid #EAEAEA;
  border-bottom: 1px solid #EAEAEA;
  
  
`;

export const NavItem = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 0;
  color: #4A4B4A;
  font-size: 16px;
  font-weight: 400;
  text-decoration: none;
  letter-spacing: 0;
  line-height: 19px;
  
  &:hover,
  &:visited {
    color: ${themes.components.colors.font};
  }


  div {
    display: flex;
    width: 38px;
  }

  > svg {
    margin-left: auto;
  }
`

export const RowInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 80%;
  padding: 11px 4px;
  border-bottom: 1px solid #EAEAEA;

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    span {
      color: ${themes.components.colors.label};
      font-size: 12px;
      letter-spacing: 0;
      line-height: 16px;
    }

    p {
      color: ${themes.components.colors.input};
      font-size: 16px;
      letter-spacing: 0;
      line-height: 22px;
      margin: 4px 0 0;
    }
  }

  a {
    text-decoration: none;
    background: transparent;
    border: 0;
    margin-left: auto;

    svg {
      height: 15px;
      width: auto;
    }
  }
`;